import angular from 'angular';
import { AlertComponent } from './alert.component';

export const AlertModule = angular
  .module('app.directives.alert', [])
  .component('updAlert', AlertComponent);
